/** @jsx jsx */
import { jsx } from 'theme-ui'
import { css } from '@emotion/core'
// eslint-disable-next-line no-unused-vars
import React from 'react'
import styled from '@emotion/styled'
import Img from 'gatsby-image/withIEPolyfill'
import Layout from '../components/Layout'
import Container from '../components/Container'
import ContainerHero from '../components/ContainerHero'
import ContainerContent from '../components/ContainerContent'
import PageTitle from '../components/PageTitle'
import SEO from '../components/SEO'
import BackgroundImage from 'gatsby-background-image'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import ListeLeistungen from '../components/ListeLeistungen'
import ListeProdukte from '../components/ListeProdukte'
import ListeHidden from '../components/ListeHidden'
import Identifier from '../components/Identifier'

import SwiperCore, { Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
require('swiper/swiper.scss')

SwiperCore.use([Autoplay])

const HeroLeftContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  height: 100%;

  @media (max-width: ${props => props.theme.responsive.mediumMax}) {
    flex-wrap: wrap;
  }
`
const HeroLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  width: 100%;
  order: 2;
  padding: 0;
  font-size: ${props => props.theme.fontSizes[5]}px;

  @media (min-width: ${props => props.theme.responsive.medium}) {
    order: 1;
  }

  @media (max-width: ${props => props.theme.responsive.mediumMax}) {
    flex-wrap: wrap;
  }
`

const HeroLeftTop = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;
  border-bottom: 2px solid #000;
  flex: auto;
  overflow: hidden;
  @media (min-width: ${props => props.theme.responsive.medium}) {
    flex: 1 10 auto;
  }
`

const HeroLeftTopLeft = styled.div`
  padding: 30px 15px;
  display: flex;
  align-items: center;
  border-right: 2px solid #000;
  flex: 1;

  @media (min-width: ${props => props.theme.responsive.medium}) {
    padding: 30px;
  }

  h1 {
    font-size: ${props => props.theme.fontSizes[8]}px;
    @media (max-width: ${props => props.theme.responsive.largeMax}) {
      font-size: ${props => props.theme.fontSizes[6]}px;
    }
    @media (max-width: ${props => props.theme.responsive.smallMax}) {
      font-size: ${props => props.theme.fontSizes[4]}px;
    }
  }
`

const HeroLeftTopRight = styled.div`
  flex: 0 0 238px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    flex: 0 0 80px;
  }
`

const HeroIdentifier = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: ${props => props.theme.responsive.medium}) {
    padding: 30px;
  }
`

const HeroLogo = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  .gatsby-image-wrapper {
    max-width: 100%;
  }
  .gatsby-image-wrapper img {
    object-fit: contain !important;
  }
  @media (min-width: ${props => props.theme.responsive.medium}) {
    padding: 30px;
  }

  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    .gatsby-image-wrapper,
    .gatsby-image-wrapper img {
      width: 60px !important;
      height: 60px !important;
    }
  }
`

const HeroLeftBottom = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex: auto;
  @media (min-width: ${props => props.theme.responsive.medium}) {
    flex: 10 1 auto;
  }
`

const HeroLeftBottomLeft = styled.div`
  display: flex;
  align-items: flex-end;
  padding: 30px;
  border-right: 2px solid #000;
  flex-grow: 1;

  @media (max-width: ${props => props.theme.responsive.mediumMax}) {
    padding: 30px 15px;
  }

  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    border-right: none;
  }

  p {
    @media (max-width: ${props => props.theme.responsive.largeMax}) {
      font-size: ${props => props.theme.fontSizes[3]}px;
    }
    @media (max-width: ${props => props.theme.responsive.smallMax}) {
      font-size: ${props => props.theme.fontSizes[2]}px;
      line-height: 1.5;
    }
  }
`

const PageDescription = styled.div`
  font-size: ${props => props.theme.fontSizes[5]}px;
`

const HeroLeftBottomRight = styled.div`
  flex: 0 0 238px;
  align-items: stretch;

  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    display: none;
  }
`

const HeroCenterImage = styled(BackgroundImage)`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  flex: 1;
  height: 100%;
  width: 100%;
`

const Top = styled.div`
  width: 100%;
  display: flex;
  border-top: 2px solid #000;
  justify-content: space-between;
  align-items: stretch;
  flex-flow: row nowrap;
  @media (max-width: ${props => props.theme.responsive.mediumMax}) {
    flex-flow: row wrap;
  }
`

const TopLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  @media (max-width: ${props => props.theme.responsive.mediumMax}) {
    flex: 1 0 100%;
  }
  max-width: 100%;
  padding: 30px 0;
  > * {
    padding: 0px 15px;
    @media (min-width: ${props => props.theme.responsive.medium}) {
      padding: 10px 30px;
    }
  }

  > p {
    font-size: ${props => props.theme.fontSizes[1]}px;
    white-space: break-spaces;
    @media (min-width: ${props => props.theme.responsive.large}) {
      column-count: 2;
      column-gap: 2em;
      white-space: pre-wrap;
    }
  }

  h2,
  h3 {
    font-weight: 400;
  }

  h2 {
    font-size: ${props => props.theme.fontSizes[5]}px;
    @media (max-width: ${props => props.theme.responsive.largeMax}) {
      font-size: ${props => props.theme.fontSizes[3]}px;
    }
    @media (max-width: ${props => props.theme.responsive.smallMax}) {
      font-size: ${props => props.theme.fontSizes[2]}px;
    }
  }

  h3 {
    margin-bottom: 6px;
    font-size: ${props => props.theme.fontSizes[4]}px;
    @media (max-width: ${props => props.theme.responsive.largeMax}) {
      font-size: ${props => props.theme.fontSizes[3]}px;
    }
    @media (max-width: ${props => props.theme.responsive.smallMax}) {
      font-size: ${props => props.theme.fontSizes[2]}px;
    }
  }

  hr {
    border: none;
    border-top: 2px solid #000;
    width: 100%;
    padding: 0;
    margin: 30px 0;
    @media (max-width: ${props => props.theme.responsive.largeMax}) {
      margin: 30px 0;
    }
  }

  code {
    font-family: inherit !important;
  }

  blockquote {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
  }

  blockquote p {
    font-size: ${props => props.theme.fontSizes[5]}px;
    line-height: 1.9em;
    @media (max-width: ${props => props.theme.responsive.largeMax}) {
      font-size: ${props => props.theme.fontSizes[3]}px;
    }
    @media (max-width: ${props => props.theme.responsive.smallMax}) {
      font-size: ${props => props.theme.fontSizes[2]}px;
    }
  }

  blockquote p:first-of-type {
    margin-right: 20px;
  }

  blockquote i {
    font-style: normal !important;
  }

  blockquote p i {
    border: 2px solid ${props => props.theme.colors.green};
    padding: 4px 12px;
    white-space: nowrap;
  }

  blockquote p:first-of-type i {
    border: 2px solid ${props => props.theme.colors.green};
    border-radius: 999px;
  }

  ul li {
    list-style: none;
    position: relative;
    padding-left: 40px;
    padding-bottom: 10px;
  }

  ul li:before {
    content: '';
    display: block;
    position: absolute;
    left: 0px;
    top: 0;
    width: 26px;
    height: 26px;
    background-image: url('/images/surface.svg');
    background-position: top left;
    background-repeat: no-repeat;
    background-size: contain;
    pointer-events: none;
  }
`

const TopRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 2;
  flex: 0 1 522px;
  max-width: 522px;
  border-left: 2px solid #000;
  @media (max-width: ${props => props.theme.responsive.mediumMax}) {
    width: 100%;
    flex: 1 1 100%;
    max-width: 100%;
    border-left: none !important;
  }
  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    display: none;
  }
`

const Center = styled.div`
  display: flex;
  flex: auto;
  align-items: stretch;
  width: 100%;
  border-top: 2px solid #000;
  flex-flow: row wrap;
  @media (min-width: ${props => props.theme.responsive.medium}) {
    flex-flow: row nowrap;
  }
`

const CenterLeft = styled.div`
  flex: 1;
  padding: 30px 15px;
  @media (min-width: ${props => props.theme.responsive.medium}) {
    padding: 30px;
  }

  ul li {
    font-size: ${props => props.theme.fontSizes[5]}px;
    list-style: none;
    position: relative;
    padding-left: 50px;
    padding-bottom: 10px;

    @media (max-width: ${props => props.theme.responsive.largeMax}) {
      font-size: ${props => props.theme.fontSizes[3]}px;
      padding-left: 45px;
    }

    @media (max-width: ${props => props.theme.responsive.smallMax}) {
      font-size: ${props => props.theme.fontSizes[1]}px;
      padding-left: 40px;
    }
  }

  ul li:before {
    content: '';
    display: block;
    position: absolute;
    left: 0px;
    top: 2px;
    width: 36px;
    height: 36px;
    background-image: url('/images/surface.svg');
    background-position: top left;
    background-repeat: no-repeat;
    background-size: contain;
    pointer-events: none;
    @media (max-width: ${props => props.theme.responsive.largeMax}) {
      width: 26px;
      height: 26px;
      left: 5px;
      top: -2px;
    }
    @media (max-width: ${props => props.theme.responsive.smallMax}) {
      width: 16px;
      height: 16px;
      left: 15px;
      top: 2px;
    }
  }
`

const CenterRight = styled.div`
  display: flex;
  align-items: stretch;
  flex: 0 1 522px;
  max-width: 522px;
  border-left: 2px solid #000;

  @media (max-width: ${props => props.theme.responsive.mediumMax}) {
    width: 100%;
    flex: 1 1 100%;
    max-width: 100%;
    border-left: none !important;
  }

  > div {
    background-color: ${props => props.theme.colors.text};
    display: flex;
    align-items: flex-end;
    @media (max-width: ${props => props.theme.responsive.mediumMax}) {
      width: 100%;
    }
  }
`

const Download = styled.div`
  padding: 30px;
  color: ${props => props.theme.colors.background};
  font-size: ${props => props.theme.fontSizes[5]}px;
  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    font-size: ${props => props.theme.fontSizes[3]}px;
  }
  a {
    opacity: 1 !important;
    margin-top: 10px;
    display: inline-block;
    text-align: center;
    color: ${props => props.theme.colors.text};
    background-color: ${props => props.theme.colors.green};
    border: 2px solid ${props => props.theme.colors.green};
    padding: 6px 20px;
    border-radius: 999px;
    @media (max-width: ${props => props.theme.responsive.smallMax}) {
      font-size: ${props => props.theme.fontSizes[1]}px;
    }
  }
`

const Bottom = styled.div`
  border-top: 2px solid #000;
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  align-items: stretch;
  font-size: ${props => props.theme.fontSizes[5]}px;
  @media (min-width: ${props => props.theme.responsive.small}) {
    flex-flow: row nowrap;
    .gatsby-image-wrapper {
      height: 500px;
    }
  }

  .gatsby-image-wrapper {
    @media (max-width: ${props => props.theme.responsive.smallMax}) {
      height: 300px !important;
      max-height: 300px !important;
      img {
        height: 300px !important;
        max-height: 300px !important;
      }
    }
  }
`

const BottomLeft = styled.div`
  background-color: ${props => props.theme.colors.text};
  color: ${props => props.theme.colors.background};
  display: flex;
  flex-direction: column;
  flex: 100%;
  max-width: 100% !important;

  @media (min-width: ${props => props.theme.responsive.small}) {
    border-right: 2px solid #000;
    flex: 0 0 50%;
  }
  @media (min-width: ${props => props.theme.responsive.medium}) {
    flex: 0 0 420px;
    max-width: 420px;
    img {
      object-position: center top !important;
    }
  }
  @media (max-width: ${props => props.theme.responsive.smallMax}) {
  }
  img {
    object-position: center 10% !important;
  }
`

const Ansprechpartner = styled.div`
  padding: 30px;
  text-align: center;
  border-top: 2px solid #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: auto;
  @media (max-width: ${props => props.theme.responsive.largeMax}) {
    font-size: ${props => props.theme.fontSizes[4]}px;
  }
  @media (max-width: ${props => props.theme.responsive.mediumMax}) {
    font-size: ${props => props.theme.fontSizes[3]}px;
  }
  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    font-size: ${props => props.theme.fontSizes[2]}px;
  }
`

const Buttons = styled.div`
  padding: 30px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    padding: 15px 0;
  }
  a {
    opacity: 1 !important;
    margin: 10px 8px 0;
    min-width: 164px;
    text-align: center;
    display: inline-block;
    text-align: center;
    border: 2px solid ${props => props.theme.colors.green};
    padding: 6px 20px;
    border-radius: 999px;
    color: ${props => props.theme.colors.background};
    @media (max-width: ${props => props.theme.responsive.mediumMax}) {
      min-width: 80px;
      font-size: ${props => props.theme.fontSizes[2]}px;
    }
    @media (max-width: ${props => props.theme.responsive.smallMax}) {
      min-width: 112px;
      font-size: ${props => props.theme.fontSizes[1]}px;
    }
  }
`

const BottomRight = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

const Zitat = styled.div`
  padding: 30px;
  padding-left: 92px;
  border-top: 2px solid #000;
  position: relative;
  flex: auto;
  &:before {
    content: '”';
    font-size: 108px;
    line-height: 108px;
    font-weight: bold;
    position: absolute;
    top: 30px;
    left: 25px;
  }

  @media (max-width: ${props => props.theme.responsive.largeMax}) {
    font-size: ${props => props.theme.fontSizes[4]}px;
  }

  @media (max-width: ${props => props.theme.responsive.mediumMax}) {
    font-size: ${props => props.theme.fontSizes[3]}px;
  }

  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    font-size: ${props => props.theme.fontSizes[2]}px;
    padding: 30px 15px;
    padding-left: 50px;
    &:before {
      font-size: 64px;
      line-height: 64px;
      top: 30px;
      left: 12px;
    }
  }
`

const Referenzen = styled.div`
  padding: 30px;
  border-top: 2px solid #000;
  font-size: ${props => props.theme.fontSizes[6]}px;
  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    font-size: ${props => props.theme.fontSizes[4]}px;
    padding: 30px 15px;
  }
`

const ReferenzenListe = styled.div`
  padding: 30px 0;
  border-top: 2px solid #000;
  font-size: ${props => props.theme.fontSizes[6]}px;
  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    font-size: ${props => props.theme.fontSizes[1]}px;
  }

  .swiper-wrapper {
  }

  .swiper-sep {
    text-align: center;
  }

  .swiper-slide {
    white-space: nowrap;
    width: auto;
  }
`

const KundenStatic = styled.div`
  display: flex;
  justify-content: space-between;
`

const ContentProduktLeistung = props => {
  const {
    title,
    intBeschreibung,
    ansprechpartnerBild,
    ansprechpartnerEmail,
    ansprechpartnerName,
    ansprechpartnerTelefon,
    ansprechpartnerZitat,
    backgroundImage,
    download,
    metaTitle,
    metaDescription,
    content,
    kunden,
    contentListe,
    farbe,
  } = props.transfer

  const kundenArray = kunden && kunden.toString().split(',')

  return (
    <Layout>
      <SEO
        title={metaTitle || title}
        description={
          metaDescription ? metaDescription.internal.content : intBeschreibung
        }
      />
      <Container>
        <ContainerHero>
          <HeroLeftContainer>
            <HeroLeft>
              <HeroLeftTop>
                <HeroLeftTopLeft
                  sx={{
                    bg: `${farbe && farbe.toLowerCase()}`,
                    overflow: 'hidden',
                  }}
                >
                  <PageTitle
                    css={css`
                      text-transform: uppercase;
                      border-bottom: 2px solid #000;
                    `}
                  >
                    {title}
                  </PageTitle>
                </HeroLeftTopLeft>
                <HeroLeftTopRight>
                  {props.transfer.identifier && (
                    <HeroIdentifier>
                      <Identifier farbe={farbe}>
                        {props.transfer.identifier && props.transfer.identifier}
                      </Identifier>
                    </HeroIdentifier>
                  )}
                  {props.transfer.logo && (
                    <HeroLogo>
                      <Img
                        fixed={props.transfer.logo.fixed}
                        alt={props.transfer.logo.title}
                      />
                    </HeroLogo>
                  )}
                </HeroLeftTopRight>
              </HeroLeftTop>
              <HeroLeftBottom>
                <HeroLeftBottomLeft>
                  <PageDescription>
                    {intBeschreibung &&
                      documentToReactComponents(intBeschreibung.json)}
                  </PageDescription>
                </HeroLeftBottomLeft>
                <HeroLeftBottomRight>
                  <HeroCenterImage
                    Tag="div"
                    fluid={backgroundImage && backgroundImage.fluid}
                    backgroundColor={`#f2f2f2`}
                    title="Fullscreen Background"
                    id="fullscreenbg"
                    role="img"
                    aria-label="Fullscreen Background"
                  />
                </HeroLeftBottomRight>
              </HeroLeftBottom>
            </HeroLeft>
          </HeroLeftContainer>
        </ContainerHero>
        <ContainerContent>
          <Top>
            <TopLeft
              sx={{
                'blockquote p i': {
                  borderColor: `${farbe && farbe.toLowerCase()}`,
                },
                'blockquote p:first-of-type i': {
                  borderColor: `${farbe && farbe.toLowerCase()}`,
                },
              }}
            >
              {content && documentToReactComponents(content.json)}
            </TopLeft>
            <TopRight>
              <div>
                <ListeLeistungen />
                <ListeHidden text="Wie wir Sie sonst noch unterstützen können?">
                  <ListeProdukte />
                </ListeHidden>
              </div>
            </TopRight>
          </Top>
          <Center>
            <CenterLeft
              sx={{
                background: `${farbe && `gradient.${farbe.toLowerCase()}`}`,
              }}
            >
              {contentListe && documentToReactComponents(contentListe.json)}
            </CenterLeft>
            <CenterRight>
              {download && (
                <div>
                  <Download
                    sx={{
                      a: {
                        borderColor: `${farbe && farbe.toLowerCase()}`,
                        bg: `${farbe && farbe.toLowerCase()}`,
                        '&:hover': {
                          bg: `#000`,
                          color: `${farbe && farbe.toLowerCase()}`,
                        },
                      },
                    }}
                  >
                    <div>{title} Datenblatt</div>
                    <a
                      href={download && download.file.url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Download
                    </a>
                  </Download>
                </div>
              )}
            </CenterRight>
          </Center>
          <Bottom>
            <BottomLeft>
              <Img
                fluid={ansprechpartnerBild && ansprechpartnerBild.fluid}
                alt={ansprechpartnerBild && ansprechpartnerBild.title}
              />
              <Ansprechpartner>
                <div>Ihr Ansprechpartner</div>
                <div
                  css={css`
                    font-weight: bold;
                  `}
                >
                  {ansprechpartnerName}
                </div>

                <Buttons
                  sx={{
                    a: {
                      borderColor: `${farbe && farbe.toLowerCase()}`,
                      '&:hover': {
                        bg: `${farbe && farbe.toLowerCase()}`,
                        color: '#000',
                      },
                    },
                  }}
                >
                  <a
                    href={
                      ansprechpartnerTelefon && 'tel:' + ansprechpartnerTelefon
                    }
                  >
                    Anrufen
                  </a>
                  <a
                    href={
                      ansprechpartnerEmail && 'mailto:' + ansprechpartnerEmail
                    }
                  >
                    E-Mail
                  </a>
                </Buttons>
              </Ansprechpartner>
            </BottomLeft>
            <BottomRight>
              <Img
                fluid={backgroundImage && backgroundImage.fluid}
                alt={backgroundImage && backgroundImage.title}
              />
              <Zitat
                sx={{
                  '&:before': { color: farbe && farbe.toLowerCase() },
                }}
              >
                {ansprechpartnerZitat && ansprechpartnerZitat.internal.content}
              </Zitat>
            </BottomRight>
          </Bottom>
          {kunden && (
            <>
              <Referenzen>Bereits zufriedene Kund*innen sind:</Referenzen>
              <ReferenzenListe>
                {!kunden ||
                  (kundenArray.length >= 5 && (
                    <Swiper
                      spaceBetween={50}
                      slidesPerView={'auto'}
                      speed={5000}
                      loopedSlides={21}
                      loop
                      autoplay={{
                        delay: 1,
                        disableOnInteraction: true,
                        waitForTransition: true,
                        reverseDirection: true,
                      }}
                    >
                      {kundenArray.map((kunde, index) => (
                        <SwiperSlide key={`olafndex-${index}`}>
                          {kunde}
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  ))}

                {!kunden ||
                  (kundenArray.length < 5 && (
                    <KundenStatic>
                      {kunden
                        .toString()
                        .split(',')
                        .map((kunde, index) => (
                          <span
                            key={`${kunde}-${index}`}
                            css={css`
                              padding-left: 20px;
                              padding-right: 20px;
                            `}
                          >
                            {kunde}
                          </span>
                        ))}
                    </KundenStatic>
                  ))}
              </ReferenzenListe>
            </>
          )}
        </ContainerContent>
      </Container>
    </Layout>
  )
}

export default ContentProduktLeistung
